export const services = [];

export const contactInfo = {
  phone: "9900590051",
  whatsapp: "919900590051",
  email: "customercare@vhfms.com",
  address: "1-49/16 SVP colony Tiruchanur, Tirupati urban, Tirupati district, Pincode:517503",
  brandName: "Venkateswara Hospitality & Facilities Management services"
};
